import { render } from "./AjaxTable.vue?vue&type=template&id=dd317c82"
import script from "./AjaxTable.vue?vue&type=script&lang=js"
export * from "./AjaxTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__